import { Inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { environment } from '@environments/environment';
import { GlobalConstants } from './global-constants';
import { DOCUMENT } from '@angular/common';
import { Helpers } from './helpers';

/**
 * This will be loaded before the Angular App gets initialized.
 * This is where we should initialize the app title, Analytics services, TMX config, etc.
 */
@Injectable()
export class GlobalConfigService {
	public titleChanged: Subject<string> = new Subject<string>();

	constructor(
		private titleService: Title,
		@Inject(DOCUMENT) private document: HTMLDocument
	) {}

	/**
	 * This function will be called as a provider before the entire app is initialized.
	 */
	public init(): void {
		const tmxSessionID = sessionStorage.getItem('eqSessionId');
		if (tmxSessionID) {
			this.sessionId = tmxSessionID;
		} else {
			this.sessionId = Helpers.generateUniqueId();
		}
		this.setVersion();
		this.loadLoginAppScript();
	}

	// Stores the sessionId in the Session Storage to use it later in the TMX script
	set sessionId(value: string) {
		if (!sessionStorage.getItem('sbbSessionId')) {
			sessionStorage.setItem('sbbSessionId', value);
		}
	}

	// Retrieves the sessionId from the Session Strage to attach it to the TMX script
	static get sessionId(): string | null {
		if (!sessionStorage.getItem('sbbSessionId')) {
			sessionStorage.setItem('sbbSessionId', Helpers.generateUniqueId());
		}
		return sessionStorage.getItem('sbbSessionId');
	}

	/**
	 * Sets app title and includes the build information for non-production environments.
	 */
	private setVersion(): void {
		const appTitle = `${GlobalConstants.APP_TITLE}`;
		this.titleService.setTitle(appTitle);
	}

	/**
	 * Includes the systemjs script needed to load the Login MFE
	 */
	private loadLoginAppScript(): void {
		const script = this.document.createElement('script');
		script.type = 'systemjs-importmap';
		script.text = `{
			"imports": {
				"ob-login-web": "${environment.loginUrl}/main.js"
			}
		}`;
		this.document.head.appendChild(script);
	}
}
